import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2f835984"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card-box"
};
const _hoisted_2 = {
  key: 0,
  class: "manager-card"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = {
  key: 1,
  class: "online-card"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  key: 2,
  class: "student-card"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = {
  key: 0,
  class: "menu-list"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "left"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "menu-title"
};
const _hoisted_13 = {
  key: 1,
  class: "menu-card"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "card-text"
};
const _hoisted_17 = {
  key: 4,
  class: "bind-box"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bind-tips-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "bind-img",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202410/158f6e5123594148a1241d048e62121f.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "bind-tips"
}, [/*#__PURE__*/_createElementVNode("div", null, "绑定智慧树账号"), /*#__PURE__*/_createElementVNode("div", null, "优享更多服务")])], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Right = _resolveComponent("Right");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_TipDialog = _resolveComponent("TipDialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [$props.zhsRole == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("a", {
    href: $data.managerLink,
    target: "_blank"
  }, null, 8, _hoisted_3)])) : $props.zhsRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("a", {
    href: $data.newOnlineLink,
    target: "_blank"
  }, null, 8, _hoisted_5)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("a", {
    href: $props.onlineLink,
    target: "_blank"
  }, null, 8, _hoisted_7)])), $options.uuid() ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [$props.zhsRole == 3 || $props.zhsRole == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "menu-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
      src: item.icon_url,
      alt: "",
      class: "menu-icon"
    }, null, 8, _hoisted_11), _createElementVNode("span", _hoisted_12, _toDisplayString(item.app_name), 1)]), _createVNode(_component_el_icon, {
      class: "arrow-icon"
    }, {
      default: _withCtx(() => [_createVNode(_component_Right)]),
      _: 1
    })], 8, _hoisted_9);
  }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "card-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("img", {
      src: item.icon_url,
      class: "card-icon",
      alt: ""
    }, null, 8, _hoisted_15), _createElementVNode("span", _hoisted_16, _toDisplayString(item.app_name), 1)], 8, _hoisted_14);
  }), 128))]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", {
    class: "bind-btn",
    type: "primary",
    round: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goToBind && $options.goToBind(...args))
  }, "去绑定 >")]))]), _createVNode(_component_TipDialog, {
    show: $data.showDialog,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.showDialog = $event)
  }, null, 8, ["show"])], 64);
}